import NewDriver from "../../../../components/@users/drivers/NewDriver";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function DriverNewPage() {

    return (
        <NewDriver 
            routeType={routeTypes.admin}
        />
    )
}       